import { BorderStyle } from './BorderStyleSelect.types';

import { ReactComponent as SolidLineIcon } from 'assets/icons/solid_line.svg';
import { ReactComponent as DashedLineIcon } from 'assets/icons/dashed_line.svg';
import { ReactComponent as DottedLineIcon } from 'assets/icons/dotted_line.svg';

const BORDER_STYLE_OPTIONS = [
  {
    value: BorderStyle.Solid,
    label: 'Solid',
    icon: <SolidLineIcon />,
  },
  {
    value: BorderStyle.Dashed,
    label: 'Dashed',
    icon: <DashedLineIcon />,
  },
  {
    value: BorderStyle.Dotted,
    label: 'Dotted',
    icon: <DottedLineIcon />,
  },
];

export { BORDER_STYLE_OPTIONS };
